<template>
  <div>

    <el-tabs v-model="activeName"  type="border-card" @tab-click="handleClick"  style="height: 100%"  >

      <el-tab-pane label="扫描" name="scan">
        <el-row>
          <el-col :span="4">
            <div  class="search-form"> 

              <el-alert v-if="scanForm.examId != null && (!isBindCard )" center type="error" effect="dark" style="margin-top: 20px;">
                    <div>
                        <span>您尚未绑定答题卡</span> <el-button type="text" size ="mini" icon="search" @click='isBindCardRoute'>点击绑定</el-button>
                    </div>
                </el-alert>

                <el-alert v-if="scanForm.examId != null && (!isAnswer)" center type="error" effect="dark" style="margin-top: 20px;">
                    <div>
                        <span>您尚未设置答案</span>
                         <!-- <el-button type="text" size ="mini" icon="search" @click='openNewExamTopicDialog'>点击设置</el-button> -->
                    </div>
                </el-alert>

                
                <el-card class="box-card" >
                    <!-- 长度限制下，超出三位会断行（上下都一样） -->
                    <div style="font-size: 30px;color: red;font-weight: bold; ">
                        <span>定位异常：</span>
                        <span style="font-size: 28px;color: red;">{{ exceptList.length  }}</span>
                        <span> 张</span>
                    </div>

                </el-card>

                <el-card class="box-card2"  >

                    <div style="font-size: 20px;font-weight: bold;">  
                        <span>已上传：</span>
                        <span style="font-size: 28px;color: #007bff;">{{ totalResult }}</span>
                        <span> 张</span>
                    </div> 
                    

                        <table border="1 " style="margin-top: 20px;width: 100%;">
                            <tr>
                                <th>序号</th>
                                <th>批次</th>
                                <th>数量(张)</th>
                            </tr>
                            <tr v-for="(item, index) in batchResult" :key="index">  
                                <td>{{ batchResult.length - index }}</td>  
                                <td>{{ item.batch_id }} </td>  
                                <!-- <td>{{ item.total_num }} </td>   -->
                                <td>{{ item.db_nums }} </td>  
                            </tr>  
                        </table>
                </el-card>

            </div>
          </el-col>
          <el-col :span="20">
            <div class="hg-scan">
                <!-- 搜索表单 -->
                <el-form :inline="true" :model="scanForm" :rules="scanRules" ref="scanForm" class="search-form">
                  <div class="form-left">
                    <el-form-item label="扫描仪：" prop="deviceName">
                        <el-select v-model="scanForm.deviceName" filterable placeholder="请选择扫描仪" style="min-width: 200px;" @change="deviceChange">
                            <el-option v-for="item in deviceList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="考试列表：" prop="examId" >
                        <el-select v-model="scanForm.examId" filterable placeholder="请选择" style="min-width: 160px;width: 300px" @change="examChange">
                          <el-option v-for="item in examList" :key="item.id" :label="item.name+'('+item.id+')'" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  style="margin-right: 5px;margin-left: -20px">
                      <!-- <el-button type="primary" size="mini" icon="el-icon-printer" :disabled="!isCanShowDeviceSettings" @click="openDeviceParamSetting">参数设置</el-button> -->
                      <el-checkbox v-model="single" label="单面" border @change="getPaperType('单面',null)" style="margin-right: 5px"></el-checkbox>
                      <el-checkbox v-model="double" label="双面" border @change="getPaperType('双面',null)"></el-checkbox>
                    </el-form-item>

                    <el-form-item style="margin-right: 10px">
                        <el-button type="primary" size="mini" :disabled="(!canScan || !wsConnected) || isScanning || !isBindCard" @click="startScan" >开始扫描</el-button>
                        <el-button type="danger" size="mini" :disabled=" ! isScanning" @click="stopScan" >停止扫描</el-button>
                    </el-form-item>

                    <el-form-item style="margin-top: -15px;margin-right: 10px">
                      <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                          content="考试全部答题卡扫描结束后，点击此按钮通知服务人员进行处理">
                          <el-button style="color: #ffffff; background-color: #67c23a;" slot="reference"  @click="wxSend" >通知服务人员</el-button>
                        </el-popover>    
                    </el-form-item>

                    
                  </div>

                  <div class="form-left">
                    <el-form-item style="display: flex;">
                        <!-- <el-button type="primary" size="mini" icon="el-icon-printer"  @click="test">test</el-button> -->
                        <!-- <el-button type="text" :disabled="!isCanShowDeviceSettings" @click="openDeviceParamSetting" >参数设置</el-button> -->

                        
                        <el-popover
                          placement="top-start"
                          width="200"
                          trigger="hover"
                    
                          content="系统已设置标准扫描模式，遇特殊情况才可点击进行更多设置">
                          <el-button type="text" slot="reference" :disabled="!isCanShowDeviceSettings" @click="openDeviceParamSetting" >特殊参数设置</el-button>
                        </el-popover>    
                    </el-form-item>
                  </div>

                </el-form>


                <!-- 状态提示 -->
                <el-alert v-if="!wsConnected" center type="warning" effect="dark" :closable="false">
                    <span>扫描服务未连接，请确保华高扫描服务已启动</span>
                </el-alert>

                <!-- <el-alert v-if="wsConnected && deviceList.length === 0" center type="info" effect="dark" :closable="false">
                    <span>未检测到扫描仪设备，请检查设备连接</span>
                </el-alert> -->

                <!-- 扫描统计 -->
                <div v-if="imageList.length > 0" style="margin-top: 15px;">
                    <el-alert center style="background-color: #3087FF !important;"
                        :title="'已扫描 ' + imageList.length + ' 张图片，已上传 ' + uploadedCount + ' 张，待上传 ' + pendingCount + ' 张'" effect="dark">
                    </el-alert>
                </div>

                <!-- 图片列表 -->
                <div class="image-style">
  
                  <el-row v-if="imageList.length > 0" style="margin-top: 15px;">
                      <el-col :span="5" v-for="(item, index) in imageList" :key="index" :offset="(index % 4) > 0 ? 1 : 0" style="padding: 10px;">
                          <el-card :body-style="{ padding: '0px' }" :class="{ 'uploaded-card': item.status === 'uploaded', 'uploading-card': item.status === 'uploading' }">
                              <el-image class="image" fit="contain"
                                        :src="item.base64" :preview-src-list="previewList">
                              </el-image>
                              <div style="padding: 14px;">
                                  <span class="image-name" :title="item.fullName">{{ item.fileName }}</span>
                                  <div class="bottom clearfix">
                                      <el-tag v-if="item.status === 'pending'" type="info" size="mini">待上传</el-tag>
                                      <el-tag v-if="item.status === 'uploading'" type="warning" size="mini">上传中</el-tag>
                                      <el-tag v-if="item.status === 'uploaded'" type="success" size="mini">已上传</el-tag>
                                      <el-tag v-if="item.status === 'error'" type="danger" size="mini">上传失败</el-tag>
                                      <!-- <el-button type="text" size="mini" class="button" @click="deleteImage(index)">删除</el-button> -->
                                  </div>
                              </div>
                          </el-card>
                      </el-col>
                  </el-row>

                </div>

                <!-- 上传按钮 v-if="imageList.length > 0 && pendingCount > 0" -->
                <el-row  class="floating-buttons" style="margin-top: 30px;">
                    <el-col :span="12" :offset="6" style="text-align: center;">
                        <el-button class="upload-btn" type="primary" icon="el-icon-upload" :loading="isUploading" @click="uploadAll" :disabled="imageList.length == 0 || scanForm.examId == null  || !isBindCard">上传</el-button>
                        <!-- <el-button class="upload-btn" type="primary" icon="el-icon-upload" :loading="isUploading" @click="uploadAll" >测试上传</el-button> -->
                    </el-col>
                </el-row>

            </div>
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane label="定位异常" name="locationError">
        <div class="location-layout" v-show="exceptList.length != 0">
          <el-row class="full-height-row">

              <el-col :span="3" class="location-title">
                  <div class="location-div">
                      <el-row class="data-row" v-if="exceptList && exceptList.length > 0" v-for="(item, index) in exceptList">
                          <el-col :span="24" style="margin-top: 10px;">
                              <el-link type="primary" @click="getLocationSrc(item)">{{getExceptName(index+1, item)}}</el-link>
                          </el-col>
                      </el-row>
                  </div>
              </el-col>

              <el-col :span="18" >
                  <div class="image-container" @wheel="handleWheel" style="height: 100%">  
                      <img v-if="imgUrl != null" :src="imgUrl" alt="Description" :style="{ transform: `scale(${scale})` , height: '100%'}" />  
                  </div>  
                  <!-- <img src="https://sh-vknow-admin.obs.cn-east-3.myhuaweicloud.com/exam_v1/4832/20260323_173113628/10.jpg"/>   -->
              </el-col>

              <el-col :span="2"></el-col>

          </el-row>
        </div>

        <h1  v-show="exceptList.length == 0" style="font-size: 25px; text-align:center">  无定位异常的数据 </h1>

      </el-tab-pane>

      <el-tab-pane label="答题卡校对" name="scantron"  >
          <!-- 以管理员端待校对页面为准 -->

          <div class="location-layout" v-show="preList.length != 0">
            <el-row class="full-height-row">

                <el-col :span="3" class="location-title">
                    <div class="location-div">
                        <el-row class="data-row" v-if="preList && preList.length > 0" v-for="(item, index) in preList">
                            <el-col :span="24" style="margin-top: 10px;">
                                <el-link type="primary" @click="openWaiting(item)">{{index+1+(waitForm.pageNo-1)*waitForm.pageSize}}、卷{{"-"+item.seq}}{{item.page_no > 1?"-第二页":""}}</el-link>
                              </el-col>
                        </el-row>
                    </div>
                </el-col>
                <el-col :span="18" >
                    <waitPage ref="waitPage"  :info="selWait"  :percentType="percentType" @ok="examChange" @changeExam="waitCurrentChange(1)"></waitPage>
                </el-col>
                <el-col :span="2"></el-col>
            </el-row>
          </div>

          <h1  v-show="preList.length == 0" style="font-size: 25px; text-align:center">  考试数据已校对结束</h1>

      </el-tab-pane>


    </el-tabs>



    <!-- 扫描参数设置 -->
    <el-dialog title="扫描设定"  :visible.sync="openShowDeviceSettings"  width="50%">
      <div class="messageBox">
        <el-form ref="form" :model="scanParams" label-width="120px"
                style="padding-left:10px">
          <el-tabs v-model="activeNameConfig">
            <el-tab-pane style="margin: 18px" label="设备参数" name="1">

              <div v-if="deviceOpened">
                <el-tabs type="border-card">
                  <el-tab-pane v-for="(groupParam,groupIndex) in scanParamsRange" :key="groupIndex"
                              :label="groupParam.group_name">
                    <el-form-item v-for="(singleParam,singleParamIndex) in groupParam.group_param" :key="singleParamIndex"
                                  :label="singleParam.name" label-width="auto">


                      <el-switch v-if="singleParam.value_type==='bool'"
                                v-model="scanParams[groupIndex].group_param[singleParamIndex].value"></el-switch>


                      <el-select v-else-if="singleParam.value_type==='string'"
                                v-model="scanParams[groupIndex].group_param[singleParamIndex].value"
                                placeholder="请选择">
                        <el-option v-for="(paramRange,index) in singleParam.value_list" :label="paramRange"
                                  :value="paramRange"></el-option>
                      </el-select>


                      <el-input-number
                          v-else-if="singleParam.value_type==='double'&&singleParam.range_type==='min_max'"
                          v-model="scanParams[groupIndex].group_param[singleParamIndex].value"
                          :min="singleParam.value_min"
                          :precision="2"
                          :step="0.01"
                          placeholder="请输入"
                          :max="singleParam.value_max"></el-input-number>

                      <el-input-number
                          v-else-if="singleParam.value_type==='int'&&singleParam.range_type==='min_max'"
                          v-model="scanParams[groupIndex].group_param[singleParamIndex].value"
                          :min="singleParam.value_min" :step="1" :precision="0"
                          placeholder="请输入"
                          :max="singleParam.value_max"></el-input-number>

                      <el-select
                          v-else-if="singleParam.value_type=='int'&&singleParam.range_type==='list'"
                          v-model="scanParams[groupIndex].group_param[singleParamIndex].value"
                          placeholder="请选择">
                        <el-option v-for="(paramRange,index) in singleParam.value_list" :label="paramRange"
                                  :value="paramRange"></el-option>
                      </el-select>

                      <el-input-number
                          v-else-if="singleParam.value_type=='int'&&singleParam.range_type==undefined"
                          v-model="scanParams[groupIndex].group_param[singleParamIndex].value"
                          :min="1" :step="1" :precision="0"
                          placeholder="请输入"
                          :max="9999"></el-input-number>
                    </el-form-item>
                  </el-tab-pane>
                </el-tabs>
              </div>

            </el-tab-pane>

            <el-tab-pane style="margin: 18px" label="全局配置" name="3" :disabled="!deviceOpened">
              <el-form-item label="文件保存目录">
                <el-input v-model="globalConfig.file_save_path"
                          placeholder="请输入文件保存目录"></el-input>
              </el-form-item>
              <!--                                        <el-form-item label="文件绑定目录">-->
              <!--                                            <el-input v-model="bindFolderPath"-->
              <!--                                                      placeholder="请输入文件绑定目录"></el-input>-->
              <!--                                        </el-form-item>-->

              <el-form-item label="文件名前缀">
                <el-input v-model="globalConfig.file_name_prefix"
                          placeholder="请输入文件名前缀"></el-input>
              </el-form-item>

              <el-form-item label="文件命名规则">
                <el-select v-model="globalConfig.file_name_mode" placeholder="请选择命名规则">
                  <el-option label="date_time" value="date_time"></el-option>
                  <el-option label="random" value="random"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="文件保存格式">
                <el-select v-model="globalConfig.image_format" placeholder="请选择格式">
                  <el-option label="jpg" value="jpg"></el-option>
                  <el-option label="png" value="png"></el-option>
                  <el-option label="bmp" value="bmp"></el-option>
                  <el-option label="tif" value="tif"></el-option>
                  <el-option label="pdf" value="pdf"></el-option>
                  <el-option label="ofd" value="ofd"></el-option>
                  <el-option label="ocr-pdf" value="ocr-pdf"></el-option>
                  <el-option label="ocr-ofd" value="ocr-ofd"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="jpg图片质量" v-show='globalConfig.image_format=="jpg"'>
                <el-slider v-model="globalConfig.image_jpeg_quality" :min="0"
                          :max="100"></el-slider>
              </el-form-item>


              <el-form-item label="tiff压缩方式" v-show='globalConfig.image_format=="tif"'>

                <el-select v-model="globalConfig.image_tiff_compression">
                  <el-option label="none" value="none"></el-option>
                  <el-option label="lzw" value="lzw"></el-option>
                  <el-option label="jpeg" value="jpeg"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="tiff压缩质量"
                            v-show='globalConfig.image_format=="tif"&&globalConfig.image_tiff_compression=="jpeg"'>
                <el-slider v-model="globalConfig.image_tiff_jpeg_quality" :min="0"
                          :max="100"></el-slider>
              </el-form-item>
            </el-tab-pane>

          </el-tabs>

        </el-form>
        <el-row style="text-align:center" v-if="deviceOpened">
          <el-button type="primary" @click="saveParams()">保存</el-button>
        </el-row>

      </div>
    </el-dialog>


    <!-- 全屏遮罩 -->
    <div class="mask" v-if="isUploading">
      <div class="loading-box">
        <h1>正在上传中，请稍等...</h1>
      </div>
    </div>


  </div>
</template>

<script>
    import { mapState } from 'vuex'
    import XEUtils from 'xe-utils'
    import * as simpleApi from "request/simple";
    // 华高扫描仪控制器
    import './HgWebScanController.js'
    import waitPage from "./waitPage";

    // 常量定义
    const SOCKET_CONNECTED = 1
    const SOCKET_DISCONNECTED = 2
    const SOCKET_EVENT = 3

    export default {
        name: 'HgScan',
        data() {
            return {
              isCanShowDeviceSettings: false,
              openShowDeviceSettings: false,
              examList: [],
              // WebSocket连接状态
              wsConnected: false,
              wsConnecting: false,
              scanController: null,

              // 扫描仪控制器
              deviceList: [],

                // 设备列表
              deviceOpened: false,
              currentDevice: null,

              // 参数设置标签页默认选中
              activeNameConfig: '1',
              //扫描参数
              scanParams: {
                color_mode: 'gray',//"color","gray","binary","auto"
                page_mode: 'simplex',//"simplex","duplex","filter_blank_general","filter_blank_invoice","fold_in_half"
                resolution: 150,//dpi  100,150,200,240,300
                brightness: 140,//亮度 1~255
                contrast: 4,//对比度  1~7
                gamma: 1.00,//伽马值  0.01~5.00
                paper_size: 'auto',//纸张尺寸 "a3","a4","a4_horz","auto"
                paper_cut_enabled: false,//是否裁剪
                paper_cut_left: 0.0,//单位毫米
                paper_cut_top: 0.0,//
                paper_cut_right: 210.0,//
                paper_cut_bottom: 297.0,//
                auto_crop: true //是否纠偏
              },
              //扫描参数的范围，后面根据实际获取到的覆盖更新
              scanParamsRange: {
                color_mode_list: ["color", "gray", "binary", "auto"],
                page_mode_list: ["simplex", "duplex", "filter_blank_general", "filter_blank_invoice", "fold_in_half"],
                resolution_list: [100, 150, 200, 240, 300],
                brightness_min: 1,
                brightness_max: 255,
                contrast_min: 1,
                contrast_max: 7,
                gamma_min: 0.01,
                gamma_max: 5.00,
                paper_size_list: ["a3", "a4", "a4_horz", "auto"],
                paper_size_width: 210.0,
                paper_size_height: 297.0
              },
              //全局配置
              globalConfig: {
                file_save_path: 'C:\\',	// 默认是文档目录
                file_name_prefix: 'Doc',	// 文件名前缀
                file_name_mode: 'date_time',	// 可以是date_time、random
                image_format: 'jpg',		// 格式，支持jpg、bmp、png、tif、pdf、ofd、ocr-pdf和ocr-ofd
                image_jpeg_quality: 80,	// jpg质量，0-100
                image_tiff_compression: 'lzw',		// 可以为none、 lzw和jpeg
                image_tiff_jpeg_quality: 80,			// tiff-jpeg质量，0-100
              },
              // 初始扫描配置
              scanParamsInit: [
                {
                    "group_name": "基本设置",
                    "group_param": [
                        {
                            "name": "设备类别",
                            "value": "ADF正面"
                        },
                        {
                            "name": "多流输出",
                            "value": false
                        },
                        {
                            "name": "多流输出类型",
                            "value": "彩色+灰度+黑白"
                        },
                        {
                            "name": "颜色模式",
                            "value": "256级灰度"
                        },
                        {
                            "name": "黑白图像阈值",
                            "value": 127
                        },
                        {
                            "name": "黑白图像反色输出",
                            "value": false
                        },
                        {
                            "name": "灰度或黑白图像 - 除色与增强",
                            "value": "不除色"
                        },
                        {
                            "name": "24位彩色图像 - 多流输出除红",
                            "value": false
                        },
                        {
                            "name": "24位彩色图像 - 答题卡除红",
                            "value": false
                        },
                        {
                            "name": "背景移除",
                            "value": false
                        },
                        {
                            "name": "背景色彩浮动范围",
                            "value": 80
                        },
                        {
                            "name": "锐化与模糊",
                            "value": "无"
                        },
                        {
                            "name": "去除摩尔纹",
                            "value": false
                        },
                        {
                            "name": "错误扩散",
                            "value": false
                        },
                        {
                            "name": "黑白图像噪点优化",
                            "value": false
                        },
                        {
                            "name": "噪点优化尺寸",
                            "value": 10
                        },
                        {
                            "name": "纸张尺寸",
                            "value": "匹配原始尺寸"
                        },
                        {
                            "name": "自定义扫描区域",
                            "value": false
                        },
                        {
                            "name": "扫描区域左侧（mm）",
                            "value": 0
                        },
                        {
                            "name": "扫描区域右侧（mm）",
                            "value": 210
                        },
                        {
                            "name": "扫描区域上侧（mm）",
                            "value": 0
                        },
                        {
                            "name": "扫描区域下侧（mm）",
                            "value": 297
                        },
                        {
                            "name": "尺寸检测",
                            "value": false
                        },
                        {
                            "name": "扫描页面",
                            "value": "单面"
                        },
                        {
                            "name": "跳过空白页",
                            "value": false
                        },
                        {
                            "name": "跳过空白页灵敏度",
                            "value": 30
                        },
                        {
                            "name": "跳过空白页边缘宽度（mm）",
                            "value": 20
                        },
                        {
                            "name": "对折模式",
                            "value": "左右对折"
                        },
                        {
                            "name": "分辨率",
                            "value": 150
                        },
                        {
                            "name": "画质",
                            "value": "画质优先"
                        },
                        {
                            "name": "交换正反面",
                            "value": false
                        }
                    ]
                },
                {
                    "group_name": "亮度",
                    "group_param": [
                        {
                            "name": "亮度值",
                            "value": 150
                        },
                        {
                            "name": "对比度",
                            "value": 4
                        },
                        {
                            "name": "伽马值",
                            "value": 1
                        }
                    ]
                },
                {
                    "group_name": "图像处理",
                    "group_param": [
                        {
                            "name": "色彩校正",
                            "value": false
                        },
                        {
                            "name": "自动纠偏",
                            "value": true
                        },
                        {
                            "name": "图像拆分",
                            "value": false
                        },
                        {
                            "name": "消除黑框",
                            "value": true
                        },
                        {
                            "name": "背景填充方式",
                            "value": "凸多边形"
                        },
                        {
                            "name": "色彩填充",
                            "value": false
                        },
                        {
                            "name": "阈值",
                            "value": 40
                        },
                        {
                            "name": "背景抗噪等级",
                            "value": 8
                        },
                        {
                            "name": "边缘缩进",
                            "value": 5
                        },
                        {
                            "name": "深色样张",
                            "value": false
                        },
                        {
                            "name": "防止渗透",
                            "value": false
                        },
                        {
                            "name": "防止渗透等级",
                            "value": "较弱"
                        },
                        {
                            "name": "穿孔移除—左侧",
                            "value": false
                        },
                        {
                            "name": "左侧穿孔搜索范围占幅面比例",
                            "value": 0.099991
                        },
                        {
                            "name": "穿孔移除—右侧",
                            "value": false
                        },
                        {
                            "name": "右侧穿孔搜索范围占幅面比例",
                            "value": 0.099991
                        },
                        {
                            "name": "穿孔移除—上侧",
                            "value": false
                        },
                        {
                            "name": "上侧穿孔搜索范围占幅面比例",
                            "value": 0.099991
                        },
                        {
                            "name": "穿孔移除—下侧",
                            "value": false
                        },
                        {
                            "name": "下侧穿孔搜索范围占幅面比例",
                            "value": 0.099991
                        }
                    ]
                },
                {
                    "group_name": "送纸方式设置",
                    "group_param": [
                        {
                            "name": "待纸扫描",
                            "value": false
                        },
                        {
                            "name": "待纸扫描退出时间",
                            "value": "60s"
                        },
                        {
                            "name": "扫描张数",
                            "value": "连续扫描"
                        },
                        {
                            "name": "扫描数量",
                            "value": 1
                        },
                        {
                            "name": "文稿方向",
                            "value": "-90°"
                        },
                        {
                            "name": "背面旋转180°",
                            "value": false
                        },
                        {
                            "name": "镜头脏污检测",
                            "value": false
                        },
                        {
                            "name": "超声波检测",
                            "value": true
                        },
                        {
                            "name": "双张图片处理",
                            "value": "丢弃图像并停止扫描"
                        },
                        {
                            "name": "装订检测",
                            "value": false
                        },
                        {
                            "name": "歪斜检测",
                            "value": true
                        },
                        {
                            "name": "歪斜容忍度",
                            "value": 3
                        },
                        {
                            "name": "折角检测",
                            "value": false
                        },
                        {
                            "name": "折角大小",
                            "value": 70
                        },
                        {
                            "name": "自动分纸强度",
                            "value": false
                        },
                        {
                            "name": "进纸失败率",
                            "value": 0.099991
                        },
                        {
                            "name": "分纸强度",
                            "value": "一般"
                        },
                        {
                            "name": "休眠时间",
                            "value": "不休眠"
                        }
                    ]
                }
              ],
              // 初始全局配置
              globalConfigInit:{
                image_format: 'png',		// 格式，支持jpg、bmp、png、tif、pdf、ofd、ocr-pdf和ocr-ofd
                file_name_mode: 'date_time',	// 可以是date_time、random
              },
              // 表单数据
              scanForm: {
                  deviceName: '',
                  examId: null,
                  storagePath: 'scans/' + XEUtils.toDateString(new Date(), 'yyyyMMdd') + '/'
              },
              scanRules: {
                  deviceName: [{ required: true, message: '请选择扫描仪', trigger: 'change' }],
                examId: [{ required: true, message: '请选择试卷', trigger: 'blur' }],
              },
              // 扫描状态
              canScan: false,
              isScanning: false,
              isUploading: false,
              autoUpload: false,
              
              // 图片列表
              imageList: [],
             
              scanIndex: 0,
              // OBS配置
              obsConfigVisible: false,
              obsConfig: {
                  accessKey: '',
                  secretKey: '',
                  server: 'obs.cn-east-3.myhuaweicloud.com',
                  bucket: ''
              },
              
              // 批次ID
              batchId: null,
              // 判断考试是否绑定答题卡
              isBindCard: true, 
              // 判断考试是否设置答案
              isAnswer: true,
              examCount: {
                ocring: 0,
                except: 0, 
                ocred: 0
              },
              // 统计扫描列表
              batchResult:[],
              batchTotal: 0,
              testNum: 0,
              paperType: 1,
              // 默认单面扫描
              single: true,
              double: false,
              // 标签页
              activeName: 'scan',
              // 定位异常列表
              locationsErrorList:[],
              exceptList:[],
              imgUrl: null,
              basicInfo: [],
              scale: 1, // 初始缩放比例  
              // 图片列表
              imgList:[],
              imgUrl_page: null,
              imgUrl_A: null,
              imgUrl_B: null,
              // 答题卡校对列表
              preList:[],
              waitForm: { 
                pageNo: 1,
                pageSize: 50, 
                totalCount: 0, 
                searchText: null,  
              },
              selWait: null,
              // 原始配置备份
              originalSavePath: '',
              originalPrefix: '',
              // 客观题换算比例版本
              percentType: false

            }
        },
        computed: {
            ...mapState({
                userInfo: state => state.user.userInfo,
            }),
            // 已上传数量
            uploadedCount() {
                return this.imageList.filter(item => item.status === 'uploaded').length
            },
            // 待上传数量
            pendingCount() {
                return this.imageList.filter(item => item.status === 'pending' || item.status === 'error').length
            },
            // 预览图片列表
            previewList() {
                return this.imageList.map(item => item.base64)
            },
            // 计算总的上传总数
            totalResult(){
              let sum = 0
              this.batchResult.forEach(item=> sum += item.db_nums)
              return sum
            }
        },
        components:{
          waitPage
        },
        mounted() {
          this.loadExamList();
            this.initWebSocket()
        },
        beforeDestroy() {
            if (this.scanController) {
                this.scanController.disconnect()
            }
        },
        methods: {
          loadExamList(){
            debugger
            let search = { licenceId: this.userInfo.licenceId, schoolId: null, teacherId: null, scan: 'Y'};
            let role = this.userInfo.role;
            if(role == "sclAdmin") search["schoolId"] = this.userInfo.schoolId;
            if(role == "teacher") {
              search["schoolId"] = this.userInfo.schoolId;
              search["scanTeacherId"] = this.userInfo.id;
            }
            let param = { controllerName: 'exam', methodName: '/examList', pageNo: 0, pageSize: 500, param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
              console.log(data)
              if (data.code == 0) {
                this.examList = data.result;
              }
            }).catch((error) => {
              console.log("error")
            });
          },
            // 初始化WebSocket连接
            initWebSocket() {
                const that = this
                this.wsConnecting = true
                
                // 创建扫描控制器实例
                this.scanController = new WebScanController({
                    wsUrl: 'ws://127.0.0.1:38999',
                    wslicence: 'gE/rN4vZATMg49y/OCFlZA=='
                })
                
                // 初始化Socket连接
                this.scanController.initSocketIo(function(result) {
                    // console.log('Socket消息:', result)
                    
                    if (result.code === 1) {
                        that.wsConnected = true
                        that.wsConnecting = false
                        that.$notify({  type: 'success' , message: '扫描服务连接成功'});
                        console.log('扫描服务连接成功:')
                        // 初始化设备
                        that.scanController.isDeviceInit()
                    } else if (result.code === 2) {
                        that.wsConnected = false
                        that.wsConnecting = false
                        // that.$message.error('扫描服务连接断开')
                        that.$notify({  type: 'error' , message: '扫描服务连接断开'});
                    } else if (result.code === 3) {
                        // 处理扫描事件
                        that.handleSocketEvent(result.data)
                    }
                })
            },
            
            // 处理Socket事件
            handleSocketEvent(data) {
                try {
                    const event = JSON.parse(data)
                    console.log('事件:', event)
                    if (event.func === 'start_scan') {
                        // 扫描开始
                        if (event.ret === 0) {
                            this.isScanning = true
                            this.$message({ type: 'success', message: `扫描已开始`,offset: 100});
                        }
                    } else if (event.func === 'stop_scan') {
                        // 扫描停止
                        this.isScanning = false
                        // 更新初始扫描文件保存地址
                        this.restoreOriginalConfig()
                        this.$message({ type: 'info', message: `扫描已停止`,offset: 100});
                    } else if (event.func === "is_device_init") {
                      if (event.ret === 0){
                        console.log('设备已初始化', event)
                        this.scanController.getDeviceNameList()
                      }else{
                        this.scanController.initDevice()
                      }
                    } else if (event.func === "init_device") {
                      if (event.ret === 0){
                        console.log('设备初始化完成', event)
                        this.scanController.getDeviceNameList()
                      }
                    } else if (event.func === "get_device_name_list") {
                      console.log('获取到设备列表', event)
                      if (event.device_name_list) {
                        this.deviceList = event.device_name_list || []
                        if (this.deviceList.length > 0) {
                          this.scanForm.deviceName = this.deviceList[0]
                          this.scanController.openDevice()
                        }
                      }
                    } else if (event.func === "open_device") {
                      console.log('打开设备完成', event)
                      this.canScan = true
                      this.currentDevice = this.scanForm.deviceName
                      // this.$message.success('设备已就绪: ' + this.scanForm.deviceName)
                      this.$notify({  type: 'success' , message: `设备已就绪 ${this.scanForm.deviceName}`});


                      // this.scanController.getScanParams();
                      // this.scanController.getGlobalConfig();

                      // 在设备已就绪时 获取设备配置
                      this.scanController.getScanParams();
                      this.scanController.getGlobalConfig();
                      

                      this.isCanShowDeviceSettings = true;
                      this.deviceOpened = true;
                    } else if (event.func === "get_device_param") {
                      // 获取扫描仪配置（扫描仪方面的）
                      this.scanParamsRange = event.device_param
                      this.parameterCoerceIn(event.device_param)

                      // 更新初始化配置
                      this.setScanParamsByInit()
                    } else if (event.func === "get_global_config") {
                      // 获取扫描仪全局配置
                      this.$set(this.globalConfig, 'file_save_path', event.file_save_path)
                      this.$set(this.globalConfig, 'file_name_prefix', event.file_name_prefix)
                      this.$set(this.globalConfig, 'file_name_mode', event.file_name_mode)
                      // this.$set(this.globalConfig, 'file_name_mode', "counter")
                      // this.$set(this.globalConfig, 'counter_start', 0)

                      this.$set(this.globalConfig, 'image_format', event.image_format)
                      this.$set(this.globalConfig, 'image_jpeg_quality', event.image_jpeg_quality)
                      this.$set(this.globalConfig, 'image_tiff_compression', event.image_tiff_compression)
                      this.$set(this.globalConfig, 'image_tiff_jpeg_quality', event.image_tiff_jpeg_quality)
                      this.$set(this.globalConfig, 'image_jp2_ratio', event.image_jp2_ratio)
 

                      // 保留最原始的文件保存地址
                      this.originalSavePath = event.file_save_path
                      // 读取初始化扫描仪配置时，更新扫描仪配置为默认配置
                      this.setGlobalParamsByInit()
                    } else if (event.func === "set_global_config") {
                      console.log("设置参数成功");
                      // this.$message.success("设置参数成功")

                    } else if (event.func === "set_device_param") {
                      console.log("设置全局配置成功");
                      // this.$message.success("设置全局配置成功")


                    } else if (event.func === "scan_image") {
                      let imageBase64 = event.image_base64;
                      let imagePath = event.image_path;
                      this.addImageToList(imageBase64, imagePath)
                    } else if (event.func === "scan_end") {
                      // 扫描结束更新扫描状态
                      this.isScanning = false
                      // 更新初始扫描文件保存地址
                      this.restoreOriginalConfig()

                      // console.log("扫描结束....")
                      // this.$message({ type: 'success', message: `扫描结束!`,offset: 100});
                    }
                } catch (e) {
                    console.error('解析事件失败:', e)
                }
            },
          addImageToList: function(imageBase64, imagePath) {
            // let fileName = imagePath.match(/[^\\/]+$/)[0]
            let extension4 = imagePath.substring(imagePath.lastIndexOf('.') + 1)
            let fileName = this.scanIndex + `.${extension4}`
            let m = {base64: imageBase64, fullName: imagePath, fileName: fileName, status: "pending"}
            // 最新的图片放在最前
            this.imageList.unshift(m);
            // this.imageList.push(m);
            this.scanIndex ++;
            console.log("图片数量", this.imageList.length)
          },
          // 导入华高扫描仪配置
          parameterCoerceIn: function (paramsRange) {

            this.scanParams = new Array()
            for (var i = 0; i < paramsRange.length; i++) {
              var group = paramsRange[i]
              var newGroup = {
                group_name: group.group_name,
                group_param: new Array()
              }
              for (var j = 0; j < group.group_param.length; j++) {
                newGroup.group_param.push({
                  name: group.group_param[j].name,
                  value: group.group_param[j].value
                })
              }
              this.scanParams.push(newGroup)
            }
            console.log('当前扫描参数：', this.scanParams)
            this.$forceUpdate()
          },
          saveParams: function () {
            // 防止更新了扫描单双页
            // debugger
            this.checkConfigByPaperType()
            this.openShowDeviceSettings = false
            // this.scanController.setGlobalConfig()
            this.setScanParams();
          },
          // 参数设置处，插入新的扫描配置
          setScanParams: function () {
            var that = this
            // 更新设备参数
            var ori = this.scanParams
            var result = new Array()
            for (var i = 0; i < ori.length; i++) {
              var group = ori[i].group_param
              for (var j = 0; j < group.length; j++) {
                if (group[j].value != undefined) {
                  result.push({
                    name: group[j].name,
                    value: group[j].value
                  })
                }
              }
            }
            // 更新扫描参数
            var config = this.globalConfig
            var globalResult = new Array()
            for(let key in config){
              // 更新配置
              globalResult[key] = config[key]
            }
            

            // this.scanController.setScanParams()

            // 保存参数后 重新应用参数到设备（需要带参数触发 handleSocketEvent）
            this.scanController.setScanParams(result)
            this.scanController.setGlobalConfig(globalResult)
          },
          // 读取设备初始的扫描信息后，配置默认的初始配置
          setScanParamsByInit(){
            // 初始扫描配置
            let ori = this.scanParamsInit
            let result = new Array()
            for (var i = 0; i < ori.length; i++) {
              var group = ori[i].group_param
              for (var j = 0; j < group.length; j++) {
                if (group[j].value != undefined) {
                  result.push({
                    name: group[j].name,
                    value: group[j].value
                  })
                }
              }
            }
            // 更新初始化配置
            this.scanController.setScanParams(result)
          },
          // 读取设备初始的全局信息后，配置默认的初始配置
          setGlobalParamsByInit(){
            // 初始全局配置
            let config = this.globalConfig
            let initG = this.globalConfigInit
            for(let key in initG){
              config[key] = initG[key]
            }
            this.scanController.setGlobalConfig(config)
          },
          // 正式扫描时，更新全局配置的保存地址，带上考试号和批次号
          setGlobalParamsByUpload(callback){
            let config = this.globalConfig
            let savaPath = config.file_save_path
            let uploadPath = savaPath + "\\" +  this.scanForm.examId + "\\" + this.batchId + "\\"
            config.file_save_path = uploadPath
            this.scanController.setGlobalConfig(config)
             // 保存配置，保存成功后执行回调
            // this.scanController.setGlobalConfig(config, (response) => {
            //   debugger
            //     if (response && response.ret === 0) {
            //         console.log('扫描路径设置成功')
            //         if (callback) callback()
            //     } else {
            //         this.$notify({ type: 'error', message: '设置扫描路径失败' })
            //     }
            // })
          },
          // 设置默认扫描参数
          setDefaultScanParams() {
              const params = {
                  pixel_type: 'rgb24',
                  resolution: 200,
                  scan_mode: 'flatbed'
              }
              this.scanController.setScanParams(params, function(result) {
                  console.log('设置扫描参数结果:', result)
              })
          },
          openDeviceParamSetting(){
            // this.scanController.getScanParams();
            // this.scanController.getGlobalConfig();
            this.openShowDeviceSettings = true;
          },
            
          // 开始扫描
          startScan() {
            this.imageList = []
            this.$refs.scanForm.validate((valid) => {
                  if (valid) {

                      if (!this.wsConnected) {
                          // this.$message.error('扫描服务未连接')
                          this.$notify({  type: 'error' , message: '扫描服务未连接'});
                          return
                      }
                      if (!this.canScan) {
                          // this.$message.error('设备未就绪')

                          this.$notify({  type: 'error' , message: '设备未就绪'});
                          return
                      }
                      
                      // 生成批次ID
                      this.batchId = XEUtils.toDateString(new Date(), 'yyyyMMddHHmmssSSS')
                      this.autoUpload = false
                      this.scanIndex = 0;
                      // 开始扫描前更新扫描地址
                      // debugger
                      this.setGlobalParamsByUpload()
                      // (() => 
                        // debugger
                        // 开始扫描
                        const that = this
                        this.scanController.startScan(function(result) {
    
                            console.log('开始扫描结果:', result)
                            if (result.code === 0) {
                                that.isScanning = true
                            } else {
                                // that.$message.error('扫描启动失败: ' + result.msg)
                                that.$notify({  type: 'error' , message: '扫描启动失败'});
                            }
                            // 无论扫描是否成功，都更新全局配置的保存地址为最原始的保存地址
                            
                        })
                        // that.restoreOriginalConfig()

                      // })
                  }
              })
          },
          restoreOriginalConfig() {
            if (this.originalSavePath) {
                this.$set(this.globalConfig, 'file_save_path', this.originalSavePath)
                // 保存恢复后的配置到后端
                this.scanController.setGlobalConfig(this.globalConfig)
                console.log('已恢复原始配置:', this.originalSavePath)
            }
          },
          stopScan(){
            this.$message({ type: 'error', message: `停止扫描中，请稍等`,offset: 100});
            // 更新扫描地址
            // this.restoreOriginalConfig()
            this.scanController.stopScan()
          },
          // 启用临时配置开始扫描
          startScanBy(){
            this.imageList = []
            this.$refs.scanForm.validate((valid) => {
                  if (valid) {

                      if (!this.wsConnected) {
                          // this.$message.error('扫描服务未连接')
                          this.$notify({  type: 'error' , message: '扫描服务未连接'});
                          return
                      }
                      if (!this.canScan) {
                          // this.$message.error('设备未就绪')

                          this.$notify({  type: 'error' , message: '设备未就绪'});
                          return
                      }
                      
                      // 生成批次ID
                      this.batchId = XEUtils.toDateString(new Date(), 'yyyyMMddHHmmssSSS')
                      this.autoUpload = false
                      this.scanIndex = 0;

                      debugger
                      const tempConfig = {
                        file_save_path: this.globalConfig.file_save_path + "//" +  this.scanForm.examId + "//" + this.batchId + "//",  // A地址或B地址
                        file_name_prefix: this.globalConfig.file_name_prefix,
                        file_name_mode: this.globalConfig.file_name_mode,
                        image_format: this.globalConfig.image_format,  // 其他参数用默认
                        image_jpeg_quality: this.globalConfig.image_jpeg_quality
                    }   
                     
                        // 开始扫描
                        const that = this
                        this.scanController.startScan(tempConfig, (result) => {
    
                            console.log('开始扫描结果:', result)
                            if (result.code === 0) {
                                that.isScanning = true
                            } else {
                                // that.$message.error('扫描启动失败: ' + result.msg)
                                that.$notify({  type: 'error' , message: '扫描启动失败'});
                            }
                        })

                      // })
                  }
              })

          },
          // 上传全部图片
          async uploadAll() {
              if (this.isUploading) return;

              let examId = parseInt(this.scanForm.examId);
              // 扫描电脑本地上传地址
              let deviceName = this.scanForm.deviceName;
              let userId = this.userInfo.id;
              this.isUploading = true;
              // 批次号(毫秒级)
              this.batchId = XEUtils.toDateString(new Date(), 'yyyyMMdd_HHmmssSSS');
              // debugger
              // 此批次真实上传成功的图片
              let count = 0
              let failImageList = []
              // for(let i=0; i < this.imageList.length; i++) {
              for(let i = this.imageList.length - 1; i >= 0; i--) {
                let m = this.imageList[i];
                // 跳过上传状态的图片
                if(m.status === 'uploaded' || m.status === 'uploading') {
                  console.log(`第${i + 1}张，状态是${m.status},跳过`);
                  continue;
                }
                // 修改图片状态至上传中
                m.status = 'uploading';
                // 配置OBS地址
                let ossName = `exam_v1/${examId}/${this.batchId}/${m.fileName}`
                // let ossName = `/exams/test/${this.batchId}/${m.fileName}`
                let param = {
                  licenceId: this.userInfo.licenceId, examId: examId, seq: i, schoolId: this.userInfo.schoolId,
                  crur: userId, crurType: this.userInfo.role, batchId: this.batchId, status: 'P0', driveInfo: deviceName,
                  driveLocalName: m.fullName, ossName: ossName
                };
                if("newId" in m){
                  param["id"] = m.newId
                }
                // 单张图片生成上传OBS桶的临时URL(临时签名) 并且插入临时状态"P0"的数据
                const resp = await simpleApi.post( { controllerName: 'scan/hg/scanPre', methodName: '/save/presign', param: param});
                if(resp.code === 0 && resp.result && resp.result.code === 0) {
                  // debugger
                  // 临时签名url生成成功后
                  let preSignedUrl = resp.result.data.preSignedUrl;
                  let newId = resp.result.data.newId;
                  m['newId'] = newId;
                  console.log("ossName", ossName);
                  console.log("获取到授权链接", newId, preSignedUrl);


                  // 将 base64(扫描仪) 转成 Blob
                  let base64Data = m.base64 || ''; // 假设 m.base64 是 base64 字符串
                  let byteCharacters = atob(base64Data.split(',')[1] || base64Data); // 去掉 data:image/...;base64, 前缀
                  let byteNumbers = new Array(byteCharacters.length);
                  for (let j = 0; j < byteCharacters.length; j++) {
                    byteNumbers[j] = byteCharacters.charCodeAt(j);
                  }
                  let byteArray = new Uint8Array(byteNumbers);
                  let blob = new Blob([byteArray], { type: m.mimeType || 'image/jpeg' });

                  try {
                    // debugger
                    // 实际上传图片至华为云
                    let uploadResp = await fetch(preSignedUrl, {
                      method: 'PUT',
                      body: blob,
                      headers: {
                        'Content-Type': 'image/jpeg'
                      }
                    });

                    // console.log(`第${i + 1}张`, uploadResp);

                    // 上传成功
                    if (uploadResp.ok) {

                      // console.log(`第${i + 1}张图片上传成功`, m.fileName);
                      // this.$message.success(`上传${ m.fileName}成功！`)
                      this.$notify({  type: 'success' , message: `上传${ m.fileName}成功！`});
                      count = count + 1

                      const updateResp = await simpleApi.post( { controllerName: 'scan/hg/scanPre', methodName: '/status/update', param: {id: newId}});
                      // console.log(`第${i + 1}张更新状态`, updateResp);
                      if(updateResp.code === 0 && updateResp.result && updateResp.result.code === 0) {
                        m.status = 'uploaded';
                      }else{
                        m.status = 'error';
                      }
                    } else {
                      // this.$message.error(`上传${ m.fileName}失败！`)
                      this.$notify({  type: 'error' , message: `上传${ m.fileName}失败！`});
                      console.error(`第${i + 1}张图片上传失败`, m.fileName, await uploadResp.text());
                      m.status = 'error';
                      failImageList.push(m)
                      // 归至上传失败列表
                    }
                  } catch (err) {
                    console.error(`第${i + 1}张图片上传异常`, m.fileName, err);
                    m.status = 'error';
                    failImageList.push(m)
                  }
                } else {
                  console.error('获取预签名URL失败', resp);
                  // 归至上传失败列表
                  failImageList.push(m)
                }
                console.log('uploadSuccess', resp);
              }
              // debugger
              // 图片上传结束后，更新左侧上传数据
              // this.batchResult.unshift({index: this.batchResult.length +1 ,batchId: this.batchId, nums: count})
              // this.batchTotal += count
              this.addScanLog(count)

              // 判断是否存在未被上传的图片，如果存在提示存在又被上传的数据 已经仅显示未被上传的图片
              if(failImageList.length > 0){
                this.imageList = failImageList
              }else{
                this.imageList = []
              }
              this.isUploading = false;
          },
            
          // 删除图片
          deleteImage(index) {
              this.$confirm('确定删除该图片吗？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                  this.imageList.splice(index, 1)
                  // this.$message.success('删除成功')
                  this.$message({ type: 'success', message: `删除成功`,offset: 100});
              }).catch(() => {})
          },
          
          // 获取临时授权
          getPreSignUrl() {
              const saved = localStorage.getItem('hgObsConfig')
              if (saved) {
                  try {
                      this.obsConfig = JSON.parse(saved)
                  } catch (e) {
                      console.error('加载OBS配置失败:', e)
                  }
              }
          },
          // 选择考试
          examChange(v){
              // 切换考试时清空上传列表
              this.batchResult = []
              this.batchTotal = 0
              console.log('examChange', v);
              let ar = XEUtils.find(this.examList, item => {
                  return item.id == v;
              })
              if(ar){
                // 判定是否绑定答案和答题卡
                  this.isBindCard = ar.exam_sheet_count>0?true:false;
                  this.isAnswer = ar.topic_answer_count > 0?false:true;
              }

              // 计算对应考试数据
              // this.loadScanCount()
              // 加载扫描记录
              this.getScanLog()
              // 加载定位异常列表
              this.loadExceptExamList()
              // 加载待校对列表
              this.loadPreList()

              if(!this.isBindCard) this.isBindCardMessage()
              
          },
          // 计算对应考试数据
          loadScanCount(){
            if(this.scanForm.examId == null) return;
              let search = { licenceId: this.userInfo.licenceId, examId: this.scanForm.examId};
              let param = { controllerName: 'scan/scanPre', methodName: '/scanCount', param: search};
              return simpleApi.post(param).then(({result: {code, data}}) =>  {
                  console.log(data)
                  this.examCount = {ocring: 0, except: 0, ocred: 0}
                  if (data) {
                      for (let i=0; i<data.length; i++){
                          this.examCount.ocring = this.examCount.ocring + data[i].status_count;
                          if(data[i].status === "Y5"){
                            this.examCount.except = this.examCount.except + data[i].status_count;
                            this.$set(this.examCount, 'except', this.examCount.except);
                          }
                      }

                  }


              }).catch((error) => {
                  console.log("error")
              });
          },
          test(){
            // debugger
            this.testNum += 1
            let name = this.testNum + ".jpg"
            let option = {
                "base64": null,
                "fullName": "C:\\Windows\\system32\\config\\systemprofile\\AppData\\Roaming\\HGWebService\\Cache\\20260324092542774.jpg",
                "fileName": name,
                "status": "pending"
            }
            this.imageList.unshift(option)
          },
          // 获取单双页类型
          getPaperType(value,type){
            if(this.paperType == value) {
              if(value == "单面") {
                this.single = true
              }else{
                this.double = true
              }
            }
            let scanMode = null

            if(value == "单面"){
              this.single = true
              this.double = false
              
              this.paperType = value
              scanMode = "单面"
              // 修改扫描配置记录
              // scan_mode: 'flatbed'
              // this.scanParams.scan_mode = "flatbed"

            }else{
              this.single = false
              this.double = true
              
              this.paperType = value
              scanMode = "双面"
              // 修改扫描配置记录
              // this.scanParams.scan_mode = "duplex"
            }

            if(type == null || type == '' || type == undefined){
              // 更新扫描配置
              this.updateScanMode(scanMode)
            }

          },
          // 查询扫描记录
          getScanLog(){
            // let search = {
            //   examId: this.scanForm.examId,
            //   teacherId: this.userInfo.id
            // }
            // let param = { controllerName: 'scan/scanPreLog', methodName: '/selectLog', param: search};

            let search = {
              examId: this.scanForm.examId
            }
            let param = { controllerName: 'scan/scanPre', methodName: '/batchListAll', param: search};
            return simpleApi.post(param).then(({result: {code, data}}) =>  {
              this.batchResult = data
            })
          },
          // 新增批次上传日志
          addScanLog(total){
            // let search = {
            //   examId: this.scanForm.examId,
            //   teacherId: this.userInfo.id,
            //   batchId: this.batchId,
            //   totalNum: total
            // }
            // let param = { controllerName: 'scan/scanPreLog', methodName: '/insertScanLog', param: search};

            // obs数量和实际插表数量
            let p = {licenceId: this.userInfo.licenceId, examId : this.scanForm.examId,batchId : this.batchId,crur: this.userInfo.id,scanType: 'web'}
            let param = { controllerName: 'scan/scanPre', methodName: '/batchCheckCount', param: p};
            return simpleApi.post(param).then(({result: {code, data}}) =>  {
              // 刷新
              this.getScanLog()
            })
          },
          // 切换标签页
          handleClick(){
            // this.checkImage = false
            
            let examId = this.scanForm.examId
            if(examId == null || examId == undefined || examId == ''){
                this.$message.warning('请选择考试号')
                return
            } 
            if(this.activeName == 'locationError'){
              // 重新读取定位异常
              this.loadExceptExamList()
            }else if(this.activeName == 'scantron'){
              // 重新读取答题卡校对
              this.loadPreList()
            }
          },
          // 加载待校对数据
          loadPreList(){
            let search = { licenceId: this.userInfo.licenceId, examId: this.scanForm.examId, inStatus: ['01']};
            let param = { controllerName: 'scan/scanPre', methodName: '/list', pageSize: 5000, param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
                console.log("loadPreList", data)
                if (data && data.code == 0) {
                    this.preList = data.result;
                }
            }).catch((error) => {
                console.log("error", error)
            });
          },

          // 加载定位异常的图片
          loadExceptExamList(){
            let search = { licenceId: this.userInfo.licenceId, examId: this.scanForm.examId, inStatus: ['Y5', 'Y6', 'Y7']};
            let param = { controllerName: 'scan/scanPre', methodName: '/list', pageSize: 5000, param: search};
            return simpleApi.list(param).then(({result: {code, data}}) =>  {
                console.log("loadExceptExamList", data)
                if (data && data.code == 0) {
                    this.exceptList = data.result;
                    // if(callback) callback(data.result);
                }
            }).catch((error) => {
                console.log("error", error)
            });
          },
          getExceptName(index, item){
              let status = item.status;
              return index + "." + "定位异常(" + item.seq+")";
              // if(status == "SY") return index + "." + "缺少第一页(" + item.seq+")";
              // if(status == "UN") return index + "." + "未知异常(" + item.seq+")";
              // if(status == "Y5") return index + "." + "找不到定位点(" + item.seq+")";
              // if(status == "Y6") return index + "." + "切图异常(" + item.seq+")";
              // if(status == "F1") return index + "." + "第一页已删除(" + item.seq+")";
              // if(status == "Y7") return index + "." + "不是这张试卷？(" + item.seq+")";
              // return index + ".异常";
          },
          getLocationSrc(item){
              this.imgUrl = item.oss_full_name
              this.basicInfo = item
          },
          handleWheel(event) {  
              event.preventDefault(); // 防止默认滚动行为  
              if (event.deltaY < 0) {  
                  this.zoomIn(); // 向上滚动放大  
              } else {  
                  this.zoomOut(); // 向下滚动缩小  
              }  
          }, 
          zoomIn() {  
              this.scale += 0.1; // 增加缩放比例  
          },  
          zoomOut() {  
              this.scale = Math.max(0.1, this.scale - 0.1); // 减少缩放比例，最小值为 0.1  
          }, 
          // 答题卡校对
          openWaiting(row){
              this.selWait = row;
          },
          // 切换单双页扫描
          updateScanMode(type){
            // debugger
            let config = this.scanParams
            let param = config[0].group_param
            for(let i in param){
              if(param[i].name =='扫描页面'){
                param[i].value = type
              }
            }
            this.setScanParams();
          },
          // 检查参数设置保存时的单双页配置
          checkConfigByPaperType(){
            let config = this.scanParams
            let param = config[0].group_param
            for(let i in param){
              if(param[i].name =='扫描页面'){
                let type = param[i].value
                if(this.paperType != type) this.getPaperType(type,1)
              }
            }
          },
          // 通知服务人员
          wxSend(){
            let that = this;
            let examId = that.scanForm.examId
            if(examId == null || examId == undefined || examId == ''){
              that.$message.warning('请选择考试号')
                return
            } 
             
            let param = { controllerName: 'wxTemplateLog', methodName: '/scanComplateLog', param: {examId: this.scanForm.examId}};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                console.log('testSend', code, data);
                that.$alert('我们将尽快处理', '收到', {
                    confirmButtonText: '确定',
                });
            });
          },
          // 未绑定答题卡不允许进行弹窗
          isBindCardMessage(){
            let title =  '提示'
            let examInfo = this.examList.filter(item => item.id == this.scanForm.examId)
            if(examInfo.length > 0) title = examInfo[0].name + '(' + examInfo[0].id + ')'
            this.$confirm('考试未绑定答题卡，请前往<strong style="font-weight: bold; color: #409eff; font-size: 14px;">笔试考试</strong>处绑定答题卡后再扫描',title,{
                confirmButtonText: '前往',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,

              }).then(() => {
                this.isBindCardRoute()
              }).catch(() => {

              });
          },
          // 前往笔试考试
          isBindCardRoute(){
            // 点击转到笔试考试
            this.$router.push('/mainPage/exam/newExam')
          },
          // 加载当前关联答题卡类型
          getScantronInfo(){
            let param = { controllerName: 'exam/scantron', methodName: '/getSheetByExamId', param: {examId: this.scanForm.examId}};
            simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
                // this.scantronInfo = data
                this.percentType = mUtils.getPercentType(data.updateTime)

            });
          },
      }
      
    }
</script>

<style lang="scss" scoped>
    .hg-scan {
        padding: 15px;
        .search-form {
            display: flex;
            justify-content: space-between;
            background: #fff;
            // padding: 18px;
            border-radius: 4px;
            margin-bottom: 15px;
        }

        .form-left {
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          align-items: center;
        }

        .form-right {
          margin-left: auto; /* 关键：自动左边距，推到右边 */
        }
                
        .image {
            width: 100%;
            height: 200px;
            display: block;
        }
        
        .image-name {
            font-size: 13px;
            color: #333;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        
        .bottom {
            margin-top: 10px;
            line-height: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .button {
            padding: 0;
        }
        
        .uploaded-card {
            border: 2px solid #67c23a;
        }
        
        .uploading-card {
            border: 2px solid #e6a23c;
        }
        
        .clearfix:before,
        .clearfix:after {
            display: table;
            content: "";
        }
        
        .clearfix:after {
            clear: both;
        }
        .floating-buttons {
          position: fixed;
          bottom: 30px; /* 距离底部30px */
          left: 0;
          right: 0;
          z-index: 999; /* 确保在最上层 */
          margin-top: 0 !important;
          pointer-events: none; /* 让容器不拦截点击事件 */
        }

        .floating-buttons .el-col {
          pointer-events: auto; /* 让按钮可以点击 */
        }

        .upload-btn {
          height: 30px;
          width: 300px; /* 固定宽度 */
          max-width: 400px;
          min-width: 150px;
        }
    }

    .image-style {
      /* 灰底底色 */
      background-color: #f5f7fa;
      
      /* 边框 */
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      
      /* 阴影 */
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      
      /* 滚动条相关 */
      max-height: 78vh;   /* 窗口高度的 78%，窗口缩小时自动缩小 */
      overflow-y: auto;   /* 垂直滚动条 */
      overflow-x: hidden; /* 隐藏水平滚动条 */
      
      /* 内边距（可选，让内容不贴边） */
      // padding: 8px;
    }
    .location-layout{
      height: 90vh;  /* 占满整个视口高度 */
      display: flex;
      flex-direction: column;
     
    }
    .full-height-row {
      flex: 1;
      display: flex;
      width: 100%;
      overflow: hidden;  /* 防止溢出 */
    }
    .location-title {
      
        height: 100%;
        // width: 100%;

        /* 边框 */
        border: 1px solid #dcdfe6;
        
        /* 圆角 */
        border-radius: 8px;
        
        /* 阴影 */
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        
        /* 背景色（可选） */
        background-color: #e6f0ff;
        
        /* 内边距（可选） */
        padding: 10px;
        

    }
    .location-div{
      height: 100%;
      width: 95%;
      border-radius: 8px;
      
    }
    .data-row{
      // background-color: red;
      border-bottom: 1px solid #e8e8e8;
      background-color: white;
      text-align: left;
      padding: 5px
    }
    .image-container {  
        width: 98%; /* 设置 div 的宽度 */  
        overflow: hidden; /* 隐藏超出部分 */  
        position: relative; /* 为了更好地控制 img 位置 */  
        margin: 10px;
    }  


    /* 全屏遮罩：禁止点击 */
    .mask {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* 提示文字样式 */
    .loading-box {
      background: #fff;
      padding: 20px 30px;
      border-radius: 6px;
      font-size: 14px;
    }
</style>
